import { transport } from 'config/transport';

export function callApiImpersonateUser(username) {
    return transport.post(`/trunguong/impersonate/${username}`);
}
